import { ViewName } from '@pressreader/navigation-types';

export const isViewName = (viewNameString: string | undefined): viewNameString is ViewName =>
    viewNameString !== undefined && Object.values(ViewName).indexOf(viewNameString as unknown as ViewName) !== -1;
